import React from 'react';

const GRAVEDADES = ['leve', 'moderada', 'grave', 'critica'];

const FormSanitario = ({ formDatos, setFormDatos, tipoSesion }) => {
  const showGravedad = ['enfermedad', 'lesion', 'mortandad'].includes(tipoSesion);
  const showTratamiento = ['enfermedad', 'medicamento', 'vacunacion', 'lesion'].includes(tipoSesion);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
      {tipoSesion === 'mortandad' && (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Causa *</label>
          <select value={formDatos.causa || ''} onChange={(e) => setFormDatos(p => ({ ...p, causa: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-causa">
            <option value="">Seleccionar</option>
            <option value="enfermedad">Enfermedad</option>
            <option value="accidente">Accidente</option>
            <option value="parto">Parto</option>
            <option value="predador">Predador</option>
            <option value="desconocida">Desconocida</option>
            <option value="otra">Otra</option>
          </select>
        </div>
      )}
      {tipoSesion === 'enfermedad' && (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Enfermedad</label>
          <input type="text" value={formDatos.enfermedad || ''} onChange={(e) => setFormDatos(p => ({ ...p, enfermedad: e.target.value }))}
            placeholder="Ej: Queratoconjuntivitis" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-enfermedad" />
        </div>
      )}
      {tipoSesion === 'vacunacion' && (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Vacuna *</label>
          <input type="text" value={formDatos.vacuna || ''} onChange={(e) => setFormDatos(p => ({ ...p, vacuna: e.target.value }))}
            placeholder="Ej: Aftosa, Clostridial" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-vacuna" />
        </div>
      )}
      {showTratamiento && (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Tratamiento / Producto</label>
          <input type="text" value={formDatos.tratamiento || ''} onChange={(e) => setFormDatos(p => ({ ...p, tratamiento: e.target.value }))}
            placeholder="Ej: Oxitetraciclina 20ml" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
        </div>
      )}
      {showTratamiento && (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Dosis</label>
          <input type="text" value={formDatos.dosis || ''} onChange={(e) => setFormDatos(p => ({ ...p, dosis: e.target.value }))}
            placeholder="Ej: 2ml/50kg" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
        </div>
      )}
      {showGravedad && (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Gravedad</label>
          <select value={formDatos.gravedad || ''} onChange={(e) => setFormDatos(p => ({ ...p, gravedad: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-gravedad">
            <option value="">Seleccionar</option>
            {GRAVEDADES.map(g => <option key={g} value={g}>{g.charAt(0).toUpperCase() + g.slice(1)}</option>)}
          </select>
        </div>
      )}
      {tipoSesion === 'lesion' && (
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Ubicacion Lesion</label>
          <input type="text" value={formDatos.ubicacion_lesion || ''} onChange={(e) => setFormDatos(p => ({ ...p, ubicacion_lesion: e.target.value }))}
            placeholder="Ej: Pata trasera der." className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
        </div>
      )}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">Detalle</label>
        <input type="text" value={formDatos.detalle || ''} onChange={(e) => setFormDatos(p => ({ ...p, detalle: e.target.value }))}
          placeholder="Descripcion..." className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">Observaciones</label>
        <input type="text" value={formDatos.observaciones || ''} onChange={(e) => setFormDatos(p => ({ ...p, observaciones: e.target.value }))}
          placeholder="Notas..." className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
      </div>
    </div>
  );
};

export default FormSanitario;
